import { render, staticRenderFns } from "./confirmrefundreturn.vue?vue&type=template&id=1bbd068b&"
import script from "./confirmrefundreturn.vue?vue&type=script&lang=js&"
export * from "./confirmrefundreturn.vue?vue&type=script&lang=js&"
import style0 from "./confirmrefundreturn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports